export default __webpack_public_path__ + "static/icon_oneuni-19f1f1de4c34115613dde5f1f3a944a2.svg";